import { DesignProp } from "../PropCategories";

export const borderWidth = {
  prop: "style-attribute",
  name: "Border width",
  nameI18n: "builder_ui.prop_type.styles.border_width",
  category: [DesignProp],
  type: "slider",
  defaultValue: "16",
  sliderProps: {
    units: ["px", "rem"],
    step: 0.25,
    min: 0,
    defaultUnit: "px",
    max: 100,
  },
} as const;
